// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__115pv","title":"AfterBackImages_title__3c4b0","images":"AfterBackImages_images__2o69U"};